import {VGLawCookie} from "vglawcookie";

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.fixedHeader($(window));
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedHeader($self);
	},
};

var lastScrollTop = 0,
	$body = $('body');

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		if (!$('body').hasClass('vg-page-static')) {
			$('[data-scrollTo="spy"]').find('a').each(function () {
				let link = $(this).attr('href');

				if (link.indexOf('/#') !== -1) {
					$(this).attr('href', link.slice(1));
				}
			});
		}

		// navigation
		new VGNav({
			expand: 'lg',
			toggle: '<i class="fal fa-chevron-down"></i>'
		}, {
			afterInit: function () {
				if (!$('body').hasClass('vg-page-static')) {
					let $vgScrollTo = $('[data-scrollTo="spy"]');

					$vgScrollTo.vgScrollToSpy({
						spy: true
					})
				}
			},
			afterClick: function () {
				$('.vg-nav-hamburger, .vg-nav-sidebar, .vg-nav-overlay').removeClass('show');
				$('body').removeClass('vg-nav-sidebar-open');
			}
		});

		new VGLawCookie({
			enableLinkMore: true,
		});

		// animation
		AOS.init({
			once: true,
		});

		// scroll
		$('[data-scrollTo]').vgScrollToSpy();

		// tooltip
		$('[data-bs-toggle="tooltip"]').tooltip();

		// Load more
		$('.btn-load-more-portfolio').each(function (){
			$(this).vegasLoadMore({
				limit: $(this).data('limit'),
				offset: $(this).data('offset'),
				route: $(this).data('route'),
				onLoad: function($self, data) {
					let target = $self.attr('data-target');

					$(target).append(data.view);

					if (!data.view) {
						$self.hide();
					}
				}
			});
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	carousel: function () {
		VegasCarousel.init();
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default, .page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('img').addClass('img-fluid');
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('header'),
			scroll = $self.scrollTop(),
			scroll_offset = $sticky.height();

		if (scroll > (scroll_offset + 200)) {
			$body.addClass('vg-hdr--is-scroll');

			$sticky.find('.vg-header-wrapper').addClass('fixed');
			$body.addClass('vg-hdr--is-fixed');

		} else {
			$sticky.find('.vg-header-wrapper').removeClass('fixed');
			$body.removeClass('vg-hdr--is-scroll vg-hdr--is-fixed');
		}
	}
};
